import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "canvas-editor" }
const _hoisted_2 = {
  key: 0,
  class: "mobile-helpers"
}
const _hoisted_3 = { class: "goBack" }
const _hoisted_4 = {
  key: 0,
  class: "layout-settings"
}
const _hoisted_5 = { class: "mobile-first-step" }
const _hoisted_6 = { class: "shape-buttons" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "transform-icon" }
const _hoisted_11 = {
  key: 1,
  class: "layout-settings"
}
const _hoisted_12 = { class: "shadow-controls" }
const _hoisted_13 = { class: "mobile-label" }
const _hoisted_14 = { class: "mobile-label" }
const _hoisted_15 = { class: "mobile-label" }
const _hoisted_16 = {
  key: 2,
  class: "layout-settings"
}
const _hoisted_17 = { class: "mobile-label" }
const _hoisted_18 = { class: "mobile-label" }
const _hoisted_19 = { class: "mobile-auto-layout" }
const _hoisted_20 = {
  key: 0,
  class: "info-item auto-layout"
}
const _hoisted_21 = { class: "info-badge" }
const _hoisted_22 = {
  key: 0,
  class: "grid-info"
}
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "info-label" }
const _hoisted_25 = { class: "info-value" }
const _hoisted_26 = { class: "info-item" }
const _hoisted_27 = { class: "info-label" }
const _hoisted_28 = { class: "info-value" }
const _hoisted_29 = {
  key: 3,
  class: "layout-settings"
}
const _hoisted_30 = { class: "mobile-label" }
const _hoisted_31 = { class: "mobile-label" }
const _hoisted_32 = { class: "arrows" }
const _hoisted_33 = {
  ref: "containerRef",
  class: "canvas-container"
}
const _hoisted_34 = {
  ref: "canvasRef",
  class: "high-quality-canvas"
}
const _hoisted_35 = {
  key: 1,
  class: "controls"
}
const _hoisted_36 = { class: "goBack" }
const _hoisted_37 = { class: "layout-settings" }
const _hoisted_38 = { class: "shape-selector" }
const _hoisted_39 = { class: "shape-buttons" }
const _hoisted_40 = { class: "icon" }
const _hoisted_41 = { class: "icon" }
const _hoisted_42 = { class: "icon" }
const _hoisted_43 = { class: "transform-title" }
const _hoisted_44 = { class: "transform-wrapper" }
const _hoisted_45 = { class: "transform-icon" }
const _hoisted_46 = { class: "layout-settings" }
const _hoisted_47 = { class: "setting-item" }
const _hoisted_48 = {
  key: 0,
  class: "shadow-controls"
}
const _hoisted_49 = { class: "setting-item" }
const _hoisted_50 = { class: "setting-item" }
const _hoisted_51 = { class: "setting-item" }
const _hoisted_52 = { class: "layout-settings" }
const _hoisted_53 = {
  key: 0,
  class: "grid-info"
}
const _hoisted_54 = { class: "info-item" }
const _hoisted_55 = { class: "info-label" }
const _hoisted_56 = { class: "info-value" }
const _hoisted_57 = { class: "info-item" }
const _hoisted_58 = { class: "info-label" }
const _hoisted_59 = { class: "info-value" }
const _hoisted_60 = {
  key: 0,
  class: "info-item auto-layout"
}
const _hoisted_61 = { class: "info-badge" }
const _hoisted_62 = { class: "setting-item" }
const _hoisted_63 = { class: "setting-item" }
const _hoisted_64 = { class: "setting-item" }
const _hoisted_65 = { class: "layout-settings" }
const _hoisted_66 = { class: "setting-item" }
const _hoisted_67 = { class: "setting-item" }
const _hoisted_68 = { class: "action-buttons" }
const _hoisted_69 = { class: "btn" }
const _hoisted_70 = { class: "btn" }
const _hoisted_71 = { class: "btn" }
const _hoisted_72 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_slider = _resolveComponent("app-slider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, { to: { name: 'cut-palette-color-view' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    size: "sm",
                    icon: ['fas', 'arrow-left']
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.t('goBack')), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_app_button, {
              severity: "secondary",
              raised: "",
              icon: ['fas', 'gear'],
              onClick: _ctx.toggleVisibleSettingsMobile
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (_ctx.isMobile && _ctx.visibleSettingsMobile)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: "settings-mobile",
              onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleVisibleSettingsMobile && _ctx.toggleVisibleSettingsMobile(...args)), ["self"]))
            }, [
              _createElementVNode("section", null, [
                (_ctx.step === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t('shapeOfElements')), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "2xl",
                              icon: ['fas', 'square'],
                              class: _normalizeClass({ active: _ctx.selectedShape === 'square' }),
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedShape = 'square'))
                            }, null, 8, ["class"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "2xl",
                              icon: ['fas', 'circle'],
                              class: _normalizeClass({ active: _ctx.selectedShape === 'circle' }),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedShape = 'circle'))
                            }, null, 8, ["class"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_font_awesome_icon, {
                              size: "2xl",
                              icon: ['fas', 'play'],
                              class: _normalizeClass({ active: _ctx.selectedShape === 'triangle' }),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedShape = 'triangle'))
                            }, null, 8, ["class"])
                          ])
                        ]),
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t('transformation')), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_font_awesome_icon, {
                            size: "xl",
                            icon: ['fas', 'undo'],
                            onClick: _ctx.rotateCanvas
                          }, null, 8, ["onClick"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('shadowSettings')), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t('intensity')) + ": " + _toDisplayString(_ctx.shadowBlur) + "px", 1),
                          _createVNode(_component_app_slider, {
                            modelValue: _ctx.shadowBlur,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.shadowBlur) = $event)),
                            min: 0,
                            max: 20
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t('yOffset')) + ": " + _toDisplayString(_ctx.shadowOffsetY) + "px", 1),
                          _createVNode(_component_app_slider, {
                            modelValue: _ctx.shadowOffsetY,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shadowOffsetY) = $event)),
                            min: 0,
                            max: 10
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t('transparency')) + ": " + _toDisplayString(_ctx.shadowOpacity) + "%", 1),
                          _createVNode(_component_app_slider, {
                            modelValue: _ctx.shadowOpacity,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shadowOpacity) = $event)),
                            min: 0,
                            max: 100
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('arrangementElements')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t('columns')) + ": " + _toDisplayString(_ctx.columns), 1),
                        _createVNode(_component_app_slider, {
                          modelValue: _ctx.columns,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.columns) = $event)),
                          min: 1,
                          max: 20
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t('rows')) + ": " + _toDisplayString(_ctx.rows), 1),
                        _createVNode(_component_app_slider, {
                          modelValue: _ctx.rows,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.rows) = $event)),
                          min: 1,
                          max: 20
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_AppCheckbox, {
                          modelValue: _ctx.autoLayout,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.autoLayout) = $event)),
                          label: "autoSelection"
                        }, null, 8, ["modelValue"]),
                        (_ctx.autoLayout)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t('auto')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.displayColors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t('colors')) + ":", 1),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.visibleCount) + " " + _toDisplayString(_ctx.t('of')) + " " + _toDisplayString(_ctx.totalCount), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t('grid')) + ":", 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.actualLayout.columns) + " × " + _toDisplayString(Math.min(_ctx.actualLayout.rows, Math.ceil(_ctx.totalCount / _ctx.actualLayout.columns))), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('sizingSettings')), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t('elementSize')) + ": " + _toDisplayString(_ctx.elementSize) + "px", 1),
                        _createVNode(_component_app_slider, {
                          modelValue: _ctx.elementSize,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.elementSize) = $event)),
                          min: 10,
                          max: 100
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t('spaceBetweenElements')) + ": " + _toDisplayString(_ctx.spacing) + "px", 1),
                        _createVNode(_component_app_slider, {
                          modelValue: _ctx.spacing,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.spacing) = $event)),
                          min: 0,
                          max: 50
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "arrow left",
                    size: _ctx.isMobile ? 'sm' : '2xl',
                    icon: ['fas', 'arrow-left'],
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.nextSection(1)))
                  }, null, 8, ["size"]),
                  _createVNode(_component_font_awesome_icon, {
                    class: "arrow right",
                    size: _ctx.isMobile ? 'sm' : '2xl',
                    icon: ['fas', 'arrow-right'],
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.nextSection(-1)))
                  }, null, 8, ["size"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("canvas", _hoisted_34, null, 512)
      ], 512),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_router_link, { to: { name: 'cut-palette-color-view' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    size: "sm",
                    icon: ['fas', 'arrow-left']
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.t('goBack')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("section", null, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t('shapeOfElements')), 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "2xl",
                        icon: ['fas', 'square'],
                        class: _normalizeClass({ active: _ctx.selectedShape === 'square' }),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectedShape = 'square'))
                      }, null, 8, ["class"])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "2xl",
                        icon: ['fas', 'circle'],
                        class: _normalizeClass({ active: _ctx.selectedShape === 'circle' }),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedShape = 'circle'))
                      }, null, 8, ["class"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "2xl",
                        icon: ['fas', 'play'],
                        class: _normalizeClass({ active: _ctx.selectedShape === 'triangle' }),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedShape = 'triangle'))
                      }, null, 8, ["class"])
                    ])
                  ])
                ]),
                _createElementVNode("section", null, [
                  _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.t('transformation')), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_font_awesome_icon, {
                        size: "xl",
                        icon: ['fas', 'undo'],
                        onClick: _ctx.rotateCanvas
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t('shadowSettings')), 1),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.enableShadow,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.enableShadow) = $event)),
                  label: "enableShadow"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.enableShadow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t('intensity')) + ":", 1),
                      _createVNode(_component_app_slider, {
                        modelValue: _ctx.shadowBlur,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.shadowBlur) = $event)),
                        min: 0,
                        max: 20
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.shadowBlur) + "px", 1)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t('yOffset')) + ":", 1),
                      _createVNode(_component_app_slider, {
                        modelValue: _ctx.shadowOffsetY,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.shadowOffsetY) = $event)),
                        min: 0,
                        max: 10
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.shadowOffsetY) + "px", 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", null, _toDisplayString(_ctx.t('transparency')) + ":", 1),
                      _createVNode(_component_app_slider, {
                        modelValue: _ctx.shadowOpacity,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.shadowOpacity) = $event)),
                        min: 0,
                        max: 100
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.shadowOpacity) + "%", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t('arrangementElements')), 1),
              (_ctx.displayColors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.t('colors')) + ":", 1),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.visibleCount) + " " + _toDisplayString(_ctx.t('of')) + " " + _toDisplayString(_ctx.totalCount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.t('grid')) + ":", 1),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.actualLayout.columns) + " × " + _toDisplayString(Math.min(_ctx.actualLayout.rows, Math.ceil(_ctx.totalCount / _ctx.actualLayout.columns))), 1)
                    ]),
                    (_ctx.autoLayout)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.t('auto')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.t('columns')) + ": ", 1),
                  _createVNode(_component_app_slider, {
                    modelValue: _ctx.columns,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.columns) = $event)),
                    min: 1,
                    max: 20
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.columns), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.t('rows')) + ": ", 1),
                  _createVNode(_component_app_slider, {
                    modelValue: _ctx.rows,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.rows) = $event)),
                    min: 1,
                    max: 20
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.rows), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_AppCheckbox, {
                    modelValue: _ctx.autoLayout,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.autoLayout) = $event)),
                    label: "autoSelection"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t('sizingSettings')), 1),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t('elementSize')) + ":", 1),
                _createVNode(_component_app_slider, {
                  modelValue: _ctx.elementSize,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.elementSize) = $event)),
                  min: 10,
                  max: 100
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.elementSize) + "px", 1)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("label", null, _toDisplayString(_ctx.t('spaceBetweenElements')) + ":", 1),
                _createVNode(_component_app_slider, {
                  modelValue: _ctx.spacing,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.spacing) = $event)),
                  min: 0,
                  max: 50
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.spacing) + "px", 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_app_button, {
                  severity: "success",
                  title: "download",
                  onClick: _ctx.saveToDevice
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_component_app_button, {
                  severity: "warning",
                  title: "saveToGallery",
                  loading: _ctx.isSaveToGallery,
                  onClick: _ctx.saveToGallery
                }, null, 8, ["loading", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createVNode(_component_app_button, {
                  severity: "info",
                  title: "addSign",
                  onClick: _ctx.openImageModal
                }, null, 8, ["onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_72, [
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: ['fas', 'ellipsis-h'],
              size: "xl",
              onClick: _withModifiers(_ctx.openPopover, ["stop"])
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_app_popover, {
      visible: _ctx.visiblePopover,
      "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.visiblePopover) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToDevice }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'download']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('download')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_popover_wrapper, null, {
          default: _withCtx(() => [
            _createVNode(_component_app_popover_item, { onClick: _ctx.saveToGallery }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'images']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('saveToGallery')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_app_popover_item, { onClick: _ctx.openImageModal }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  size: "xl",
                  icon: ['fas', 'fa-pencil-square']
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('addSign')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}